export default __webpack_public_path__ + "static/media/carouselLandscape40.2748fda9.jpg";